import type RetsListing from '@bb/domain/dist/types/RetsListing';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const findById = async (id: string) => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `/rets/listing/${id}`,
  };

  const { data } = await axios.request<RetsListing>(config);

  return data;
};

export default findById;
